import React, {useEffect, useState} from "react"
import { StyledSecondStep } from "./index.styles";
import {
  fetchDataForSpecialitiesFormAction, fetchDataForSpecialitiesFormActionReset,
  handleSetSelectedSpecialityActions
} from "../../../../../../store/pages/admission/actions";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {Form, Select, Spin} from "antd";
import {selectStore} from "../../../../../../store/selector";
import {SelectSpecialty} from "./SelectSpecialty";

const {Option} = Select;

export const SecondStep = ({
                             formRef,
                             education_order_id,
                             onFinish,
                             onFinishFailed,
                             error,
                             setError,
                             educationOrder,
                             user_id
                           }: any) => {

  const dispatch = useDispatch();
  const { t } = useTranslation('admission');

  const {admission: {getMarks: markTable, arrayOfSpecialities: arrayOfSpecialitiesState, }} = useSelector(selectStore)

  const initValue = {
    education_form: educationOrder.data ? educationOrder.data.education_form : null,
    pay_form: educationOrder.data ? educationOrder.data.pay_form : null,
    education_type: educationOrder.data ? educationOrder.data.education_type : null,
  }

  const [formData, setFormData] = useState(initValue);
  const [profileType, setProfileType] = useState(null)

  useEffect(() => {
    let values = formRef.getFieldsValue()

    if (values.education_form){
      setFormData(values)
    }

  }, [educationOrder.data]);

  useEffect(() => {
    if(formData.education_type){
      dispatch(fetchDataForSpecialitiesFormAction({type: formData.education_type}));
    }
  }, [formData.education_type]);

  useEffect(() => {
    if(arrayOfSpecialitiesState.data.length === 1){
      dispatch(fetchDataForSpecialitiesFormAction({type: formData.education_type, ...(profileType || profileType === 0 ? {profile_type: profileType === 0 ? 0 : profileType} : {})}));
    }
  }, [arrayOfSpecialitiesState.data])

  useEffect(() => {

    if (formData.pay_form === '1' && formData.education_form !== '1') {
      dispatch(fetchDataForSpecialitiesFormActionReset())
      formRef.resetFields(['pay_form'])
      formRef.resetFields(['education_type'])
    }


    // if(formData.pay_form === '1' && formData.education_type === '2'){
    //   formRef.resetFields(['education_type'])
    // }

    //eslint-disable-next-line
  }, [formData])

  useEffect(() => {
    if (education_order_id) {
      if (markTable.data && arrayOfSpecialitiesState.data.length < 1) {
        dispatch(handleSetSelectedSpecialityActions(markTable.data.educationOrder.selectedSpecialities))
      }
      formRef.setFieldsValue(initValue)


    }
    //eslint-disable-next-line
  }, [])

  const onValuesChange = (changedFields: any, allFields: any) => {
    setFormData({...formData, ...changedFields})
  };

  return(
    <StyledSecondStep>
      <div className="header">
        <h3>{t('stepTwo.selectLanguage')}</h3>
      </div>

      <div className="body">

        <Form labelCol={{ span: 5 }}
              labelAlign="left"
              wrapperCol={{ span: 17 }}
              size="large" onFinishFailed={onFinishFailed} form={formRef} onFinish={onFinish} autoComplete="off"
              name="first_step_form" initialValues={initValue} onValuesChange={onValuesChange}>
          <Form.Item name='education_form' label={t('stepTwo.eduForm.label')}
                     rules={[{ required: true, message: t("stepTwo.educationFormError") }]}>
            <Select placeholder={t('stepTwo.eduForm.selectList')}>
              <Option value='1'>{t('stepTwo.eduForm.fullTime')}</Option>
              <Option value='2'>{t('stepTwo.eduForm.distant')}</Option>
              <Option value='3'>{t('stepTwo.eduForm.evening')}</Option>
            </Select>
          </Form.Item>

          <Form.Item name='pay_form' label={t('stepTwo.payForm.label')}
                     rules={[{ required: true, message: t("stepTwo.payFormError") }]}>
            <Select placeholder={t('stepTwo.payForm.selectList')}>
              <Option value='1'>{t('stepTwo.payForm.grant')}</Option>
              <Option value='2'>{t('stepTwo.payForm.work')}</Option>
            </Select>
          </Form.Item>

          <Form.Item name='education_type' label={t('stepTwo.specialtyType.label')}
                     rules={[{ required: true, message: t("stepTwo.educationTypeError") }]}>
            <Select placeholder={t('stepTwo.specialtyType.selectList')}>
              <Option value='1'>{t('stepTwo.specialtyType.work')}</Option>
              {/*{!(formData.education_form === "1" && formData.pay_form === "1") &&*/}
              <Option value='2'>{t('stepTwo.specialtyType.bachelor')}</Option>
              {/*}*/}
            </Select>
          </Form.Item>
        </Form>

        <hr/>

          <Spin spinning={educationOrder.loading}>
              <SelectSpecialty
                educationOrder={educationOrder}
                educationForm={formData.education_form || (educationOrder.data && educationOrder.data.education_form)}
                educationType={formData.education_type || (educationOrder.data && educationOrder.data.education_type)}
                pay_form={formData.pay_form || (educationOrder.data && educationOrder.data.pay_form)}
                error={error} setError={setError} user_id={user_id} formDataTop={formData} setProfileType={setProfileType} profileType={profileType}/>
          </Spin>
      </div>


    </StyledSecondStep>
  )
}